<template>
    <CCardBox>
        <CFormGroup :label="$t('dates.publishedAt', lang)">
            {{ publishedDate }}
        </CFormGroup>

        <CFormGroup v-if="updatedDate" :label="$t('dates.updatedAt', lang)">
            {{ updatedDate }}
        </CFormGroup>
    </CCardBox>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import CCardBox from '@/components/ui/CCardBox.vue'
import CFormGroup from '@/components/ui/CFormGroup.vue'
import { daysBetween, formatDate, parseDate } from '#shared/utils'

const props = defineProps({
    // Firestore timestamps on the client SDK, ISO strings from the server API.
    publishedAt: {
        type: [Object, Date, String],
        required: true
    },
    updatedAt: {
        type: [Object, Date, String],
        required: true
    },
    lang: {
        type: String,
        default: 'sk'
    }
})

const formatDateByLang = (date: unknown) => {
    return formatDate(date, {
        locale: props.lang === 'en' ? 'en' : 'sk'
    })
}

const publishedDate = computed((): string => {
    return formatDateByLang(props.publishedAt)
})

const updatedDate = computed((): string | boolean => {
    return daysBetween(parseDate(props.publishedAt), parseDate(props.updatedAt))
        ? formatDateByLang(props.updatedAt)
        : false
})
</script>